<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>

<div [class.blur]="isLoading">
  <div class="rc-body" [class.rc-readonly]="isCancelled || isReadOnly">
    <!-- Note bar -->
    <div class="rc-note-bar">
      <span class="rc-note-text"><strong>Note:</strong> Mandatory activities (marked with *) must be completed in the
        given sequence. Optional activities may be taken in any order as per your preference.</span>
      <a class="rc-download-link" (click)="openTemplatesModal()">Download the Latest Template</a>
    </div>

    @if (templatesModalOpen) {
    <div class="templates-overlay" (click)="closeTemplatesModal()">
      <div class="templates-dialog" (click)="$event.stopPropagation()">

        <div class="templates-header">
          <h2 class="templates-title">Review Cycle Templates</h2>
          <button type="button" class="templates-close" (click)="closeTemplatesModal()" aria-label="Close">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#1a1a1a">
              <circle cx="12" cy="12" r="12" />
              <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
              <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <div class="templates-body">
          <div class="templates-panel">
            <div class="templates-panel-top">
              <div>
                <h3 class="templates-panel-title">Templates</h3>
                <p class="templates-panel-subtitle">
                  These file templates are available to support each stage of the Review Cycle.
                </p>
              </div>
              @if (reviewCycleTemplates.length > 0) {
              <button type="button" class="templates-download-all" [disabled]="isDownloadingAll"
                (click)="downloadAllTemplates()">
                {{ isDownloadingAll ? 'Preparing…' : 'Download All' }}
              </button>
              }
            </div>

            @if (reviewCycleTemplates.length > 0) {
            <ul class="templates-list">
              @for (template of reviewCycleTemplates; track template.path) {
              <li class="templates-list-item">
                <a class="templates-file-link" (click)="downloadTemplate(template)">
                  <img src="assets/documents/word-icon.png" class="templates-file-icon" />
                  {{ template.name }}
                </a>
              </li>
              }
            </ul>
            } @else {
            <p class="templates-empty">No templates available. Please contact your administrator.</p>
            }
          </div>
        </div>

        <div class="templates-footer">
          <button type="button" class="templates-close-btn" (click)="closeTemplatesModal()">Close</button>
        </div>
      </div>
    </div>
    }

    <!-- Review phases -->
    <div class="rc-phases-wrap" *ngIf="reviewTypeId === 1">
      <!-- Plan Review -->
      <div class="rc-phase">
        <div class="rc-phase-hdr rc-phase-hdr--plan">
          <span class="rc-phase-title">Plan Review</span>
          <div class="rc-phase-hdr-right">
            <a class="rc-not-applicable" (click)="!isPlanReviewReadOnly && openNotApplicableModal()">Not Applicable</a>
            <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus('PLAN') === 'NOT_STARTED',
              'in-progress': getStatus('PLAN') === 'IN_PROGRESS',
              'completed': getStatus('PLAN') === 'COMPLETED'}">

              <!-- icon -->
              <ng-container *ngIf="getStatus('PLAN') === 'NOT_STARTED'; else progressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>

              <ng-template #progressIcon>
                <ng-container *ngIf="getStatus('PLAN') === 'IN_PROGRESS'; else completedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>

              <ng-template #completedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>

            </span>
          </div>
        </div>

        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'PLAN'),
          'rc-completed': isCompleted(1,'PLAN')}">
              <ng-container *ngIf="isCompleted(1,'PLAN'); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Initial Communication <br> Send <span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to PL – Initial Communication Sent"
                matTooltipPosition="above">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(1, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][1]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][1]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(1, i, 'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 2. Kick off meeting -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'PLAN'),
          'rc-completed': isCompleted(2,'PLAN') }">
              <ng-container *ngIf="isCompleted(2,'PLAN'); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <span class="rc-act-name">
              Kick Off Meeting
            </span>
            <input type="text" class="field-input rc-date-field kickoffDate" [value]="formatDateDisplay(kickoffDate)" readonly />
          </div>

          <!-- 3. Actual kick off date -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'PLAN'),
          'rc-completed': isCompleted(3,'PLAN') }">
              <ng-container *ngIf="isCompleted(3,'PLAN'); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Actual Kick Off Date <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to PL - Kick Off Call Held">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-date-picker-wrap--disabled]="isPlanReviewReadOnly"
              (click)="openDatePicker(rcPicker_plan3, 3, 'PLAN')">
              <span class="rc-date-display">{{ formatDateDisplay(actualKickoffDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_plan3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualKickoffDate"
                [disabled]="isPlanReviewReadOnly || !isActive(3,'PLAN') && !isCompleted(3,'PLAN')"
                (change)="onDateSelected(3,'PLAN')" />
            </div>
          </div>

          <!-- 4. Meeting Minutes of Kick of Meeting Sent -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,'PLAN'),
          'rc-completed': isCompleted(4,'PLAN')}">
              <ng-container *ngIf="isCompleted(4,'PLAN'); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Meeting Minutes of Kick Off Meeting Sent</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(4, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][4]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][4]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(4, i, 'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 5. Request send for Required Document -->

          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,'PLAN'),
          'rc-completed': isCompleted(5,'PLAN')}">
              <ng-container *ngIf="isCompleted(5,'PLAN'); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Request Send for Required Document Received (Section-1)</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(5, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][5]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][5]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(5, i,'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 6. Risk Assessment & draft Engagement Letter -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6,'PLAN'),
          'rc-completed': isCompleted(6,'PLAN')}">
              <ng-container *ngIf="isCompleted(6,'PLAN'); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Risk Assessment &amp; Draft Engagement Letter (EL)</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(6, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][6]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][6]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(6, i,'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7,'PLAN'),
          'rc-completed': isCompleted(7,'PLAN') }">
              <ng-container *ngIf="isCompleted(7,'PLAN'); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Actual Planning Meeting <br> Date<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to PL - FW Confirmed">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-date-picker-wrap--disabled]="isPlanReviewReadOnly"
              (click)="openDatePicker(rcPicker_plan7, 7, 'PLAN')">
              <span class="rc-date-display">{{ formatDateDisplay(actualPlanningDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_plan7 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualPlanningDate"
                [disabled]="isPlanReviewReadOnly || !isActive(7,'PLAN') && !isCompleted(7,'PLAN')"
                (change)="onDateSelected(7,'PLAN')" />
            </div>
          </div>

          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8,'PLAN'),
          'rc-completed': isCompleted(8,'PLAN')}">
              <ng-container *ngIf="isCompleted(8,'PLAN'); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Meeting Minutes Documented &amp; Distributed (Planning Meeting) <span
                class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to SCP – Engagement Letter Issued">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(8, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][8]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][8]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(8, i,'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9,'PLAN'),
          'rc-completed': isCompleted(9,'PLAN')}">
              <ng-container *ngIf="isCompleted(9,'PLAN'); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">EL is Published<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to SCP - Engagement Letter Issued">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(9, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][9]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][9]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(9, i,'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 10 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(10,'PLAN'),
          'rc-completed': isCompleted(10,'PLAN')}">
              <ng-container *ngIf="isCompleted(10,'PLAN'); else step10Num">✓</ng-container>
              <ng-template #step10Num>10</ng-template>
            </span>
            <span class="rc-act-name">Requested Document Received from Delivery Team (Section 2)</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(10, 'PLAN')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['PLAN'][10]?.length">
                <div *ngFor="let file of uploadedFilesMap['PLAN'][10]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(10, i,'PLAN')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Conduct Review -->
      <div class="rc-phase rc-phase--conduct">
        <div class="rc-phase-hdr rc-phase-hdr--conduct">
          <span class="rc-phase-title">Conduct Review</span>
          <div class="rc-phase-hdr-right">
            <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus('CONDUCT') === 'NOT_STARTED',
              'in-progress': getStatus('CONDUCT') === 'IN_PROGRESS',
              'completed': getStatus('CONDUCT') === 'COMPLETED'}">

              <!-- icon -->
              <ng-container *ngIf="getStatus('CONDUCT') === 'NOT_STARTED'; else conductprogressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>

              <ng-template #conductprogressIcon>
                <ng-container *ngIf="getStatus('CONDUCT') === 'IN_PROGRESS'; else conductcompletedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>

              <ng-template #conductcompletedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>
            </span>
          </div>
        </div>

        <!-- Activity -->
        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'CONDUCT'),
          'rc-completed': isCompleted(1,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(1,'CONDUCT'); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Actual Fieldwork Start Date<span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to FW - Started"
                matTooltipPosition="above">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_conduct1, 1, 'CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(actualFieldWorkStartDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_conduct1 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualFieldWorkStartDate"
                [disabled]="!isActive(1,'CONDUCT') && !isCompleted(1,'CONDUCT')"
                (change)="onDateSelected(1,'CONDUCT')" />
            </div>
          </div>

          <!-- 2 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'CONDUCT'),
          'rc-completed': isCompleted(2,'CONDUCT') }">
              <ng-container *ngIf="isCompleted(2,'CONDUCT'); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <span class="rc-act-name">
              Review documentation and define the controls to be tested (Offline)
            </span>
            <div class="step-group step-group--compact">
              <label>
                <input type="radio" name="step2" value="yes" [(ngModel)]="step2TextValue"
                  (change)="onTextChange(2, 'CONDUCT')">
                Yes
              </label>

              <label>
                <input type="radio" name="step2" value="no" [(ngModel)]="step2TextValue"
                  (change)="onTextChange(2, 'CONDUCT')">
                No
              </label>
            </div>
          </div>

          <!-- 3 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'CONDUCT'),
          'rc-completed': isCompleted(3,'CONDUCT') }">
              <ng-container *ngIf="isCompleted(3,'CONDUCT'); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Agree review plan on Opening Call
            </span>
            <label class="switch switch--green">
              <input type="checkbox" [(ngModel)]="step3ToggleValue" [disabled]="isCancelled || isReadOnly"
                (change)="onToggleChange(3, 'CONDUCT')">
              <span class="slider"></span>
            </label>
          </div>

          <!-- 4 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,'CONDUCT'),
          'rc-completed': isCompleted(4,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(4,'CONDUCT'); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Perform Fieldwork and document result in the Working Papers</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(4, 'CONDUCT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['CONDUCT'][4]?.length">
                <div *ngFor="let file of uploadedFilesMap['CONDUCT'][4]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(4, i,'CONDUCT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 5 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,'CONDUCT'),
          'rc-completed': isCompleted(5,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(5,'CONDUCT'); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Discuss Status and observation within schedule Interim Meeting</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(5, 'CONDUCT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['CONDUCT'][5]?.length">
                <div *ngFor="let file of uploadedFilesMap['CONDUCT'][5]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(5, i,'CONDUCT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 6 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6,'CONDUCT'),
          'rc-completed': isCompleted(6,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(6,'CONDUCT'); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Actual Fieldwork End Date <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to FW - Completed">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_conduct6, 6, 'CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(actualFieldWorkEndDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_conduct6 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualFieldWorkEndDate"
                [disabled]="!isActive(6,'CONDUCT') && !isCompleted(6,'CONDUCT')"
                (change)="onDateSelected(6,'CONDUCT')" />
            </div>
          </div>

          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7,'CONDUCT'),
          'rc-completed': isCompleted(7,'CONDUCT') }">
              <ng-container *ngIf="isCompleted(7,'CONDUCT'); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Prepare issue summary (iSAD) and share with SDL and team lead
            </span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(7, 'CONDUCT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['CONDUCT'][7]?.length">
                <div *ngFor="let file of uploadedFilesMap['CONDUCT'][7]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(7, i,'CONDUCT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8,'CONDUCT'),
          'rc-completed': isCompleted(8,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(8,'CONDUCT'); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Pre-closing is held to agree on observations</span>
            <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="preClosingHeld"
              [disabled]="!isActive(8,'CONDUCT') && !isCompleted(8,'CONDUCT')" (change)="onDateSelected(8,'CONDUCT')" placeholder="mm/dd/yyyy" /> -->
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(8, 'CONDUCT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['CONDUCT'][8]?.length">
                <div *ngFor="let file of uploadedFilesMap['CONDUCT'][8]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(8, i,'CONDUCT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9,'CONDUCT'),
          'rc-completed': isCompleted(9,'CONDUCT')}">
              <ng-container *ngIf="isCompleted(9,'CONDUCT'); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">Actual Pre-Closing Call Meeting<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Pre Close Call Held">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_conduct9, 9, 'CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(preClosingCall) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_conduct9 type="date" class="rc-date-input-hidden"
                [(ngModel)]="preClosingCall"
                [disabled]="!isActive(9,'CONDUCT') && !isCompleted(9,'CONDUCT')"
                (change)="onDateSelected(9,'CONDUCT')" />
            </div>
          </div>

          <!-- 10 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(10,'CONDUCT'),
          'rc-completed': isCompleted(10,'CONDUCT') }">
              <ng-container *ngIf="isCompleted(10,'CONDUCT'); else step10Num">✓</ng-container>
              <ng-template #step10Num>10</ng-template>
            </span>
            <span class="rc-act-name">
              Distribute Minutes of meeting of Pre-Closing Call<span class="required">*</span><mat-icon
                class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Pre Close Call Held">info</mat-icon>
            </span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(10, 'CONDUCT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['CONDUCT'][10]?.length">
                <div *ngFor="let file of uploadedFilesMap['CONDUCT'][10]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(10, i,'CONDUCT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Review -->
      <div class="rc-phase rc-phase--report">
        <div class="rc-phase-hdr rc-phase-hdr--report">
          <span class="rc-phase-title">Report the Review</span>
          <div class="rc-phase-hdr-right">
            <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus('REPORT') === 'NOT_STARTED',
              'in-progress': getStatus('REPORT') === 'IN_PROGRESS',
              'completed': getStatus('REPORT') === 'COMPLETED'}">

              <!-- icon -->
              <ng-container *ngIf="getStatus('REPORT') === 'NOT_STARTED'; else reportprogressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>

              <ng-template #reportprogressIcon>
                <ng-container *ngIf="getStatus('REPORT') === 'IN_PROGRESS'; else reportcompletedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>

              <ng-template #reportcompletedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>
            </span>
          </div>
        </div>

        <!-- Activity -->
        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'REPORT'),
          'rc-completed': isCompleted(1,'REPORT')}">
              <ng-container *ngIf="isCompleted(1,'REPORT'); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Draft report based on agreed ISAD</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(1, 'REPORT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['REPORT'][1]?.length">
                <div *ngFor="let file of uploadedFilesMap['REPORT'][1]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(1, i,'REPORT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 2 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'REPORT'),
          'rc-completed': isCompleted(2,'REPORT') }">
              <ng-container *ngIf="isCompleted(2,'REPORT'); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <!-- <span class="rc-act-name"></span> -->
            <div class="rc-act-content">
              <span class="rc-act-name">Review/update Report</span>

              <!-- Sub item 1 -->
              <div class="rc-sub-item">
                <span>1. Reviewed by Manager</span>
                <label>
                  <input type="radio" name="mgr" value="yes" [(ngModel)]="reportReview.reviewedByManager"
                    (change)="onSubChange()">
                  Yes
                </label>

                <label>
                  <input type="radio" name="mgr" value="no" [(ngModel)]="reportReview.reviewedByManager"
                    (change)="onSubChange()">
                  No
                </label>
              </div>

              <!-- Sub item 2 -->
              <div class="rc-sub-item" [class.disabled]="!reportReview.reviewedByManager">
                <span>
                  2. Reviewed by Regional Compliance Lead, Global Risk and Compliance
                </span>

                <label>
                  <input type="radio" name="comp" value="yes" [(ngModel)]="reportReview.reviewedByCompliance"
                    [disabled]="!reportReview.reviewedByManager" (change)="onSubChange()">
                  Yes
                </label>

                <label>
                  <input type="radio" name="comp" value="no" [(ngModel)]="reportReview.reviewedByCompliance"
                    [disabled]="!reportReview.reviewedByManager" (change)="onSubChange()">
                  No
                </label>
              </div>
            </div>
          </div>

          <!-- 3 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'REPORT'),
          'rc-completed': isCompleted(3,'REPORT') }">
              <ng-container *ngIf="isCompleted(3,'REPORT'); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Send draft report for Management Response (MR) <span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Draft Sent for Mgmt Resp"
                matTooltipPosition="above">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_report3, 3, 'REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(sendDraftReportforMR) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_report3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="sendDraftReportforMR"
                [disabled]="!isActive(3,'REPORT') && !isCompleted(3,'REPORT')"
                (change)="onDateSelected(3,'REPORT')" />
            </div>
          </div>

          <!-- 4 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,'REPORT'),
          'rc-completed': isCompleted(4,'REPORT')}">
              <ng-container *ngIf="isCompleted(4,'REPORT'); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Management Response Agreed?
              <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Mgmt Resp Agreed">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_report4, 4, 'REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(MRAgreed) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_report4 type="date" class="rc-date-input-hidden"
                [(ngModel)]="MRAgreed"
                [disabled]="!isActive(4,'REPORT') && !isCompleted(4,'REPORT')"
                (change)="onDateSelected(4,'REPORT')" />
            </div>
          </div>

          <!-- 5 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,'REPORT'),
          'rc-completed': isCompleted(5,'REPORT')}">
              <ng-container *ngIf="isCompleted(5,'REPORT'); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Closing call to agree on MRs (Optional)</span>
            <div class="step-group step-group--align-end">
              <label>
                <input type="radio" name="step5" value="yes" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5, 'REPORT')">
                Yes
              </label>

              <label>
                <input type="radio" name="step5" value="no" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5, 'REPORT')">
                No
              </label>
            </div>
          </div>

          <!-- 6 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6,'REPORT'),
          'rc-completed': isCompleted(6,'REPORT')}">
              <ng-container *ngIf="isCompleted(6,'REPORT'); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Update & publish the report</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(6,'REPORT')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap['REPORT'][6]?.length">
                <div *ngFor="let file of uploadedFilesMap['REPORT'][6]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(6, i,'REPORT')">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7,'REPORT'),
          'rc-completed': isCompleted(7,'REPORT') }">
              <ng-container *ngIf="isCompleted(7,'REPORT'); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Overall Report Review Rating <span class="required">*</span>
            </span>
            <div class="rc-dropdown-container">
              <div *ngIf="!isActive(7,'REPORT') && !isCompleted(7,'REPORT')"
                   class="rc-dropdown-overlay"
                   (click)="isBlockedBySequence(7,'REPORT')"></div>
              <select class="rc-dropdown" [(ngModel)]="reportRating"
                [disabled]="!isActive(7,'REPORT') && !isCompleted(7,'REPORT')"
                (change)="onReportRatingChange(7, 'REPORT')">
                <option value="">Select</option>
                <option value="green">Green</option>
                <option value="yellow">Yellow</option>
                <option value="red">Red</option>
                <option value="blue">Blue</option>
              </select>
            </div>
          </div>

          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8,'REPORT'),
          'rc-completed': isCompleted(8,'REPORT')}">
              <ng-container *ngIf="isCompleted(8,'REPORT'); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Revised Target Publication Date
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-revdate-field--disabled]="!isActive(8,'REPORT') && !isCompleted(8,'REPORT')"
              (click)="openRevisedPubDateModal()">
              <span class="rc-date-display">
                {{ revisedTargetPublicationDate ? formatDateDisplay(revisedTargetPublicationDate) : 'DD-MMM-YYYY' }}
              </span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
            </div>
          </div>

          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9,'REPORT'),
          'rc-completed': isCompleted(9,'REPORT')}">
              <ng-container *ngIf="isCompleted(9,'REPORT'); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">Actual Publishing Date<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to IM - Published">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_report9, 9, 'REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(actualPublishingDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_report9 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualPublishingDate"
                [disabled]="!isActive(9,'REPORT') && !isCompleted(9,'REPORT')"
                (change)="onDateSelected(9,'REPORT')" />
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- Go-Live Review (reviewTypeId === 2) -->
    <div *ngIf="reviewTypeId === 2">

      <!-- Tab Bar -->
      <div class="gl-tab-bar">
        <button *ngIf="typeOfReview !== 'post-only'" class="gl-tab" [class.gl-tab--active]="glActiveTab === 'pre'"
          (click)="glActiveTab = 'pre'">Pre
          Go-Live</button>
        <button class="gl-tab" [class.gl-tab--active]="glActiveTab === 'post'" (click)="glActiveTab = 'post'">Post
          Go-Live</button>
      </div>

      <!-- Pre Go-Live Tab -->
      <div class="rc-phases-wrap" *ngIf="glActiveTab === 'pre'">

        <!-- Plan Review -->
        <div class="rc-phase">
          <div class="rc-phase-hdr rc-phase-hdr--plan">
            <span class="rc-phase-title">Plan Review</span>
            <div class="rc-phase-hdr-right">
              <a class="rc-not-applicable" (click)="!isPlanReviewReadOnly && openNotApplicableModal()">Not
                Applicable</a>
              <span class="rc-status-badge" [ngClass]="{
                'not-started': getStatus('GL_PRE_PLAN') === 'NOT_STARTED',
                'in-progress': getStatus('GL_PRE_PLAN') === 'IN_PROGRESS',
                'completed':   getStatus('GL_PRE_PLAN') === 'COMPLETED'}">
                <ng-container *ngIf="getStatus('GL_PRE_PLAN') === 'NOT_STARTED'; else glPPProgressIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" />
                    <line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                  Not Started
                </ng-container>
                <ng-template #glPPProgressIcon>
                  <ng-container *ngIf="getStatus('GL_PRE_PLAN') === 'IN_PROGRESS'; else glPPCompletedIcon">
                    <mat-icon>schedule</mat-icon>In Progress
                  </ng-container>
                </ng-template>
                <ng-template #glPPCompletedIcon>
                  <mat-icon>check_circle</mat-icon>Completed
                </ng-template>
              </span>
            </div>
          </div>

          <div class="rc-activity-list">
            <!-- 1. Kick off meeting -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(1,'GL_PRE_PLAN'), 'rc-completed': isCompleted(1,'GL_PRE_PLAN')}">
                <ng-container *ngIf="isCompleted(1,'GL_PRE_PLAN'); else glPP1">✓</ng-container>
                <ng-template #glPP1>1</ng-template>
              </span>
              <span class="rc-act-name">Kick Off Meeting</span>
              <input type="text" class="field-input rc-date-field kickoffDate" [(ngModel)]="glPrePlanKickoffDate"
                readonly />
            </div>

            <!-- 2. Actual kick off date -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(2,'GL_PRE_PLAN'), 'rc-completed': isCompleted(2,'GL_PRE_PLAN')}">
                <ng-container *ngIf="isCompleted(2,'GL_PRE_PLAN'); else glPP2">✓</ng-container>
                <ng-template #glPP2>2</ng-template>
              </span>
              <span class="rc-act-name">Actual Kick Off Date
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to PL - Kick Off Call Held">info</mat-icon>
                <span class="required">*</span>
              </span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPrePlanActualKickoffDate"
                [disabled]="!isActive(2,'GL_PRE_PLAN') && !isCompleted(2,'GL_PRE_PLAN')"
                (change)="onDateSelected(2,'GL_PRE_PLAN')" placeholder="dd-mm-yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-date-picker-wrap--disabled]="isPlanReviewReadOnly"
              (click)="openDatePicker(rcPicker_preplan2, 2, 'GL_PRE_PLAN')">
              <span class="rc-date-display">{{ formatDateDisplay(glPrePlanActualKickoffDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_preplan2 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPrePlanActualKickoffDate"
                [disabled]="isPlanReviewReadOnly || !isActive(2,'GL_PRE_PLAN') && !isCompleted(2,'GL_PRE_PLAN')"
                (change)="onDateSelected(2,'GL_PRE_PLAN')" />
            </div>
            </div>

            <!-- 3. Meeting Minutes of Kick of Meeting Sent -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(3,'GL_PRE_PLAN'), 'rc-completed': isCompleted(3,'GL_PRE_PLAN')}">
                <ng-container *ngIf="isCompleted(3,'GL_PRE_PLAN'); else glPP3">✓</ng-container>
                <ng-template #glPP3>3</ng-template>
              </span>
              <span class="rc-act-name">Meeting Minutes of Kick Off Meeting Sent <span class="required">*</span></span>
              <div class="upload-section">
                <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                  (click)="openUploadDocModal(3,'GL_PRE_PLAN')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_PLAN'][3]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_PLAN'][3]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(3, i, 'GL_PRE_PLAN')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 4. EL is published -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(4,'GL_PRE_PLAN'), 'rc-completed': isCompleted(4,'GL_PRE_PLAN')}">
                <ng-container *ngIf="isCompleted(4,'GL_PRE_PLAN'); else glPP4">✓</ng-container>
                <ng-template #glPP4>4</ng-template>
              </span>
              <span class="rc-act-name">EL is Published
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to SCP - Engagement Letter Issued">info</mat-icon>
                <span class="required">*</span>
              </span>
              <div class="upload-section">
                <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                  (click)="openUploadDocModal(4,'GL_PRE_PLAN')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_PLAN'][4]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_PLAN'][4]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(4, i, 'GL_PRE_PLAN')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 5. Information Request Document -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(5,'GL_PRE_PLAN'), 'rc-completed': isCompleted(5,'GL_PRE_PLAN')}">
                <ng-container *ngIf="isCompleted(5,'GL_PRE_PLAN'); else glPP5">✓</ng-container>
                <ng-template #glPP5>5</ng-template>
              </span>
              <span class="rc-act-name">Information Request Document</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  [class.disabled]="isPlanReviewReadOnly"
                  (click)="openUploadDocModal(5,'GL_PRE_PLAN')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_PLAN'][5]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_PLAN'][5]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(5, i, 'GL_PRE_PLAN')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Conduct Review -->
        <div class="rc-phase">
          <div class="rc-phase-hdr rc-phase-hdr--conduct">
            <span class="rc-phase-title">Conduct Review</span>
            <div class="rc-phase-hdr-right">
              <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus('GL_PRE_CONDUCT') === 'NOT_STARTED',
              'in-progress': getStatus('GL_PRE_CONDUCT') === 'IN_PROGRESS',
              'completed': getStatus('GL_PRE_CONDUCT') === 'COMPLETED'}">

                <!-- icon -->
                <ng-container *ngIf="getStatus('GL_PRE_CONDUCT') === 'NOT_STARTED'; else glconductprogressIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" />
                    <line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                  Not Started
                </ng-container>

                <ng-template #glconductprogressIcon>
                  <ng-container *ngIf="getStatus('GL_PRE_CONDUCT') === 'IN_PROGRESS'; else glconductcompletedIcon">
                    <mat-icon>schedule</mat-icon>
                    In Progress
                  </ng-container>
                </ng-template>

                <ng-template #glconductcompletedIcon>
                  <mat-icon>check_circle</mat-icon> Completed
                </ng-template>
              </span>
            </div>
          </div>

          <!-- Activity -->
          <div class="rc-activity-list">
            <!-- 1 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'GL_PRE_CONDUCT'),
          'rc-completed': isCompleted(1,'GL_PRE_CONDUCT')}">
                <ng-container *ngIf="isCompleted(1,'GL_PRE_CONDUCT'); else glPC1">✓</ng-container>
                <ng-template #glPC1>1</ng-template>
              </span>
              <span class="rc-act-name">Actual Pre Go-Live (Fieldwork Start Date)<span class="required">*</span>
                <mat-icon class="icon-info"
                  matTooltip="Once completed this activity the Review Status will change to Pre-Go-Live FW-Started"
                  matTooltipPosition="above">info</mat-icon>
              </span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPreConductFieldworkStartDate"
                [disabled]="!isActive(1,'GL_PRE_CONDUCT') && !isCompleted(1,'GL_PRE_CONDUCT')"
                (change)="onDateSelected(1,'GL_PRE_CONDUCT')" placeholder="mm/dd/yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_preconduct1, 1, 'GL_PRE_CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(glPreConductFieldworkStartDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_preconduct1 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPreConductFieldworkStartDate"
                [disabled]="!isActive(1,'GL_PRE_CONDUCT') && !isCompleted(1,'GL_PRE_CONDUCT')"
                (change)="onDateSelected(1,'GL_PRE_CONDUCT')" />
            </div>
            </div>

            <!-- 2 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'GL_PRE_CONDUCT'),
          'rc-completed': isCompleted(2,'GL_PRE_CONDUCT') }">
                <ng-container *ngIf="isCompleted(2,'GL_PRE_CONDUCT'); else glPC2">✓</ng-container>
                <ng-template #glPC2>2</ng-template>
              </span>
              <span class="rc-act-name">Perform Fieldwork and Document Result in Working Papers <span
                  class="required">*</span></span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(2,'GL_PRE_CONDUCT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_CONDUCT'][2]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_CONDUCT'][2]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(2, i,'GL_PRE_CONDUCT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 3 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'GL_PRE_CONDUCT'),
          'rc-completed': isCompleted(3,'GL_PRE_CONDUCT') }">
                <ng-container *ngIf="isCompleted(3,'GL_PRE_CONDUCT'); else glPC3">✓</ng-container>
                <ng-template #glPC3>3</ng-template>
              </span>
              <span class="rc-act-name">Discuss Status and Observation within Schedule Interim Meeting</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(3,'GL_PRE_CONDUCT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_CONDUCT'][3]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_CONDUCT'][3]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(3, i,'GL_PRE_CONDUCT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Report the Review (Pre Go-Live)-->
        <div class="rc-phase">
          <div class="rc-phase-hdr rc-phase-hdr--report">
            <span class="rc-phase-title">Report the Review (Pre Go-Live)</span>
            <div class="rc-phase-hdr-right">
              <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus('GL_PRE_REPORT') === 'NOT_STARTED',
              'in-progress': getStatus('GL_PRE_REPORT') === 'IN_PROGRESS',
              'completed': getStatus('GL_PRE_REPORT') === 'COMPLETED'}">

                <!-- icon -->
                <ng-container *ngIf="getStatus('GL_PRE_REPORT') === 'NOT_STARTED'; else glPRProgressIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" />
                    <line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                  Not Started
                </ng-container>

                <ng-template #glPRProgressIcon>
                  <ng-container *ngIf="getStatus('GL_PRE_REPORT') === 'IN_PROGRESS'; else glPRCompletedIcon">
                    <mat-icon>schedule</mat-icon>
                    In Progress
                  </ng-container>
                </ng-template>

                <ng-template #glPRCompletedIcon>
                  <mat-icon>check_circle</mat-icon> Completed
                </ng-template>
              </span>
            </div>
          </div>

          <!-- Activity -->
          <div class="rc-activity-list">
            <!-- 1 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'GL_PRE_REPORT'),
          'rc-completed': isCompleted(1,'GL_PRE_REPORT')}">
                <ng-container *ngIf="isCompleted(1,'GL_PRE_REPORT'); else glPR1Num">✓</ng-container>
                <ng-template #glPR1Num>1</ng-template>
              </span>
              <span class="rc-act-name">Interim Pre Go-Live Report <span class="required">*</span> <mat-icon
                  class="icon-info"
                  matTooltip="Once completed this activity the Review Status will change to Pre-Go-Live FW-Completed"
                  matTooltipPosition="above">info</mat-icon></span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(1,'GL_PRE_REPORT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_REPORT'][1]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_REPORT'][1]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(1, i,'GL_PRE_REPORT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 2 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'GL_PRE_REPORT'),
          'rc-completed': isCompleted(2,'GL_PRE_REPORT') }">
                <ng-container *ngIf="isCompleted(2,'GL_PRE_REPORT'); else glPR2Num">✓</ng-container>
                <ng-template #glPR2Num>2</ng-template>
              </span>
              <div class="rc-act-content">
                <span class="rc-act-name">Review/Update Interim Pre Go-Live Report</span>

                <!-- Sub item 1 -->
                <div class="rc-sub-item">
                  <span>2a. Reviewed by Manager</span>
                  <label>
                    <input type="radio" name="glPRMgr" value="yes" [(ngModel)]="glPreReportReview.reviewedByManager"
                      (change)="onSubChangeGLPre()">
                    Yes
                  </label>
                  <label>
                    <input type="radio" name="glPRMgr" value="no" [(ngModel)]="glPreReportReview.reviewedByManager"
                      (change)="onSubChangeGLPre()">
                    No
                  </label>
                </div>

                <!-- Sub item 2 -->
                <div class="rc-sub-item">
                  <span>2b. Reviewed by Regional Compliance Lead, Global Risk and Compliance</span>
                  <label>
                    <input type="radio" name="glPRComp" value="yes" [(ngModel)]="glPreReportReview.reviewedByCompliance"
                      (change)="onSubChangeGLPre()">
                    Yes
                  </label>
                  <label>
                    <input type="radio" name="glPRComp" value="no" [(ngModel)]="glPreReportReview.reviewedByCompliance"
                      (change)="onSubChangeGLPre()">
                    No
                  </label>
                </div>
              </div>
            </div>

            <!-- 3 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'GL_PRE_REPORT'),
          'rc-completed': isCompleted(3,'GL_PRE_REPORT') }">
                <ng-container *ngIf="isCompleted(3,'GL_PRE_REPORT'); else glPR3Num">✓</ng-container>
                <ng-template #glPR3Num>3</ng-template>
              </span>
              <span class="rc-act-name">
                Actual Interim Call (Pre Go-Live Fieldwork End Date) <span class="required">*</span>
                <mat-icon class="icon-info"
                  matTooltip="Once completed this activity the Review Status will change to Interim Call Held"
                  matTooltipPosition="above">info</mat-icon></span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPreReportInterimCallDate"
                [disabled]="!isActive(3,'GL_PRE_REPORT') && !isCompleted(3,'GL_PRE_REPORT')"
                (change)="onDateSelected(3,'GL_PRE_REPORT')" placeholder="mm/dd/yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_prereport3, 3, 'GL_PRE_REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(glPreReportInterimCallDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_prereport3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPreReportInterimCallDate"
                [disabled]="!isActive(3,'GL_PRE_REPORT') && !isCompleted(3,'GL_PRE_REPORT')"
                (change)="onDateSelected(3,'GL_PRE_REPORT')" />
            </div>
            </div>

            <!-- 4 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,'GL_PRE_REPORT'),
          'rc-completed': isCompleted(4,'GL_PRE_REPORT')}">
                <ng-container *ngIf="isCompleted(4,'GL_PRE_REPORT'); else glPR4Num">✓</ng-container>
                <ng-template #glPR4Num>4</ng-template>
              </span>
              <span class="rc-act-name">Meeting Minutes Send and MR Required <span class="required">*</span></span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(4,'GL_PRE_REPORT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_REPORT'][4]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_REPORT'][4]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(4, i,'GL_PRE_REPORT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 5 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,'GL_PRE_REPORT'),
          'rc-completed': isCompleted(5,'GL_PRE_REPORT')}">
                <ng-container *ngIf="isCompleted(5,'GL_PRE_REPORT'); else glPR5Num">✓</ng-container>
                <ng-template #glPR5Num>5</ng-template>
              </span>
              <span class="rc-act-name">Exceptional Approval (if applicable)</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(5,'GL_PRE_REPORT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_PRE_REPORT'][5]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_PRE_REPORT'][5]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(5, i,'GL_PRE_REPORT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Post Go-Live Tab -->
      <div class="rc-phases-wrap rc-phases-wrap--2col" *ngIf="glActiveTab === 'post'">

        <!-- Conduct Review -->
        <div class="rc-phase">
          <div class="rc-phase-hdr rc-phase-hdr--conduct">
            <span class="rc-phase-title">Conduct Review (Post Go-Live)</span>
            <div class="rc-phase-hdr-right">
              <span class="rc-status-badge" [ngClass]="{
                'not-started': getStatus('GL_POST_CONDUCT') === 'NOT_STARTED',
                'in-progress': getStatus('GL_POST_CONDUCT') === 'IN_PROGRESS',
                'completed':   getStatus('GL_POST_CONDUCT') === 'COMPLETED'}">
                <ng-container *ngIf="getStatus('GL_POST_CONDUCT') === 'NOT_STARTED'; else glPCProgressIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" />
                    <line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                  Not Started
                </ng-container>
                <ng-template #glPCProgressIcon>
                  <ng-container *ngIf="getStatus('GL_POST_CONDUCT') === 'IN_PROGRESS'; else glPCCompletedIcon">
                    <mat-icon>schedule</mat-icon>In Progress
                  </ng-container>
                </ng-template>
                <ng-template #glPCCompletedIcon>
                  <mat-icon>check_circle</mat-icon>Completed
                </ng-template>
              </span>
            </div>
          </div>

          <div class="rc-activity-list">
            <!-- 1. Actual Post Go-Live testing start date -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(1,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(1,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(1,'GL_POST_CONDUCT'); else glPC1">✓</ng-container>
                <ng-template #glPC1>1</ng-template>
              </span>
              <span class="rc-act-name">Actual Post Go-Live Testing Start / Post Go Live Fieldwork <br> Start Date
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to POST-Go-Live FW-Started">info</mat-icon>
                <span class="required">*</span>
              </span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPostConductFieldworkStartDate"
                [disabled]="!isActive(1,'GL_POST_CONDUCT') && !isCompleted(1,'GL_POST_CONDUCT')"
                (change)="onDateSelected(1,'GL_POST_CONDUCT')" placeholder="dd-mm-yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postconduct1, 1, 'GL_POST_CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(glPostConductFieldworkStartDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postconduct1 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPostConductFieldworkStartDate"
                [disabled]="!isActive(1,'GL_POST_CONDUCT') && !isCompleted(1,'GL_POST_CONDUCT')"
                (change)="onDateSelected(1,'GL_POST_CONDUCT')" />
            </div>
            </div>

            <!-- 2. Post-Go-Live-Working Paper -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(2,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(2,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(2,'GL_POST_CONDUCT'); else glPC2">✓</ng-container>
                <ng-template #glPC2>2</ng-template>
              </span>
              <span class="rc-act-name">Post-Go-Live-Working Paper</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(2,'GL_POST_CONDUCT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_POST_CONDUCT'][2]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_POST_CONDUCT'][2]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(2, i, 'GL_POST_CONDUCT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 3. Actual Post Go-Live (Fieldwork End Date) -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(3,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(3,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(3,'GL_POST_CONDUCT'); else glPC3">✓</ng-container>
                <ng-template #glPC3>3</ng-template>
              </span>
              <span class="rc-act-name">Actual Post Go-Live (Fieldwork End Date)
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to POST-Go-Live FW-Completed">info</mat-icon>
                <span class="required">*</span>
              </span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPostConductFieldworkEndDate"
                [disabled]="!isActive(3,'GL_POST_CONDUCT') && !isCompleted(3,'GL_POST_CONDUCT')"
                (change)="onDateSelected(3,'GL_POST_CONDUCT')" placeholder="dd-mm-yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postconduct3, 3, 'GL_POST_CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(glPostConductFieldworkEndDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postconduct3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPostConductFieldworkEndDate"
                [disabled]="!isActive(3,'GL_POST_CONDUCT') && !isCompleted(3,'GL_POST_CONDUCT')"
                (change)="onDateSelected(3,'GL_POST_CONDUCT')" />
            </div>
            </div>

            <!-- 4. Pre-Closing is held to agree on observations -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(4,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(4,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(4,'GL_POST_CONDUCT'); else glPC4">✓</ng-container>
                <ng-template #glPC4>4</ng-template>
              </span>
              <span class="rc-act-name">Pre-Closing is Held to Agree on Observations</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(4,'GL_POST_CONDUCT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_POST_CONDUCT'][4]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_POST_CONDUCT'][4]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(4, i, 'GL_POST_CONDUCT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 5. Actual Pre-Closing call meeting -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(5,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(5,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(5,'GL_POST_CONDUCT'); else glPC5">✓</ng-container>
                <ng-template #glPC5>5</ng-template>
              </span>
              <span class="rc-act-name">Actual Pre-Closing Call Meeting
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to RPTG - Pre Close Call Held">info</mat-icon>
                <span class="required">*</span>
              </span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glPostConductPreClosingCall"
                [disabled]="!isActive(5,'GL_POST_CONDUCT') && !isCompleted(5,'GL_POST_CONDUCT')"
                (change)="onDateSelected(5,'GL_POST_CONDUCT')" placeholder="dd-mm-yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postconduct5, 5, 'GL_POST_CONDUCT')">
              <span class="rc-date-display">{{ formatDateDisplay(glPostConductPreClosingCall) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postconduct5 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glPostConductPreClosingCall"
                [disabled]="!isActive(5,'GL_POST_CONDUCT') && !isCompleted(5,'GL_POST_CONDUCT')"
                (change)="onDateSelected(5,'GL_POST_CONDUCT')" />
            </div>
            </div>

            <!-- 6. Distribute Minute of meeting of Pre-closing call -->
            <div class="rc-activity">
              <span class="rc-act-num"
                [ngClass]="{'rc-act-num--active': isActive(6,'GL_POST_CONDUCT'), 'rc-completed': isCompleted(6,'GL_POST_CONDUCT')}">
                <ng-container *ngIf="isCompleted(6,'GL_POST_CONDUCT'); else glPC6">✓</ng-container>
                <ng-template #glPC6>6</ng-template>
              </span>
              <span class="rc-act-name">Distribute Minute of Meeting of Pre-Closing Call <span
                  class="required">*</span></span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(6,'GL_POST_CONDUCT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>
                <div *ngIf="uploadedFilesMap['GL_POST_CONDUCT'][6]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_POST_CONDUCT'][6]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(6, i, 'GL_POST_CONDUCT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Report the Review (Post Go-Live) -->
        <div class="rc-phase">
          <div class="rc-phase-hdr rc-phase-hdr--report">
            <span class="rc-phase-title">Report the Review (Post Go-Live)</span>
            <div class="rc-phase-hdr-right">
              <span class="rc-status-badge" [ngClass]="{
                'not-started': getStatus('GL_POST_REPORT') === 'NOT_STARTED',
                'in-progress': getStatus('GL_POST_REPORT') === 'IN_PROGRESS',
                'completed': getStatus('GL_POST_REPORT') === 'COMPLETED'}">

                <!-- icon -->
                <ng-container *ngIf="getStatus('GL_POST_REPORT') === 'NOT_STARTED'; else glPostRProgressIcon">
                  <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" />
                    <line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                  Not Started
                </ng-container>

                <ng-template #glPostRProgressIcon>
                  <ng-container *ngIf="getStatus('GL_POST_REPORT') === 'IN_PROGRESS'; else glPostRCompletedIcon">
                    <mat-icon>schedule</mat-icon>
                    In Progress
                  </ng-container>
                </ng-template>

                <ng-template #glPostRCompletedIcon>
                  <mat-icon>check_circle</mat-icon> Completed
                </ng-template>
              </span>
            </div>
          </div>

          <!-- Activity -->
          <div class="rc-activity-list">
            <!-- 1 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,'GL_POST_REPORT'),
          'rc-completed': isCompleted(1,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(1,'GL_POST_REPORT'); else step1Num">✓</ng-container>
                <ng-template #step1Num>1</ng-template>
              </span>
              <span class="rc-act-name">Draft Report Based on Agreed ISAD</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(1, 'GL_POST_REPORT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>

                <div *ngIf="uploadedFilesMap['GL_POST_REPORT'][1]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_POST_REPORT'][1]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(1, i,'GL_POST_REPORT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 2 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,'GL_POST_REPORT'),
          'rc-completed': isCompleted(2,'GL_POST_REPORT') }">
                <ng-container *ngIf="isCompleted(2,'GL_POST_REPORT'); else step2Num">✓</ng-container>
                <ng-template #step2Num>2</ng-template>
              </span>
              <!-- <span class="rc-act-name"></span> -->
              <div class="rc-act-content">
                <span class="rc-act-name">Review/Update Report</span>

                <!-- Sub item 1 -->
                <div class="rc-sub-item">
                  <span>2a. Reviewed by Manager</span>
                  <label>
                    <input type="radio" name="mgr1" value="yes" [(ngModel)]="glreportReview.glreviewedByManager"
                      (change)="onSubChangeGLPost()">
                    Yes
                  </label>

                  <label>
                    <input type="radio" name="mgr2" value="no" [(ngModel)]="glreportReview.glreviewedByManager"
                      (change)="onSubChangeGLPost()">
                    No
                  </label>
                </div>

                <!-- Sub item 2 -->
                <div class="rc-sub-item">
                  <span>
                    2b. Reviewed by Regional <br> Compliance Lead, Global Risk and Compliance
                  </span>

                  <label>
                    <input type="radio" name="comp1" value="yes" [(ngModel)]="glreportReview.glreviewedByCompliance"
                      (change)="onSubChangeGLPost()">
                    Yes
                  </label>

                  <label>
                    <input type="radio" name="comp2" value="no" [(ngModel)]="glreportReview.glreviewedByCompliance"
                      (change)="onSubChangeGLPost()">
                    No
                  </label>
                </div>
              </div>
            </div>

            <!-- 3 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,'GL_POST_REPORT'),
          'rc-completed': isCompleted(3,'GL_POST_REPORT') }">
                <ng-container *ngIf="isCompleted(3,'GL_POST_REPORT'); else step3Num">✓</ng-container>
                <ng-template #step3Num>3</ng-template>
              </span>
              <span class="rc-act-name">
                Send Draft Report for Management <br> Response (MR) <span class="required">*</span>
                <mat-icon class="icon-info"
                  matTooltip="Once completed this activity the Review Status will change to RPTG - Draft Sent for Mgmt Resp"
                  matTooltipPosition="above">info</mat-icon></span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glsendDraftReportforMR"
                [disabled]="!isActive(3,'GL_POST_REPORT') && !isCompleted(3,'GL_POST_REPORT')" (change)="onDateSelected(3,'GL_POST_REPORT')"
                placeholder="mm/dd/yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postreport3, 3, 'GL_POST_REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(glsendDraftReportforMR) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postreport3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glsendDraftReportforMR"
                [disabled]="!isActive(3,'GL_POST_REPORT') && !isCompleted(3,'GL_POST_REPORT')"
                (change)="onDateSelected(3,'GL_POST_REPORT')" />
            </div>
            </div>

            <!-- 4 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,'GL_POST_REPORT'),
          'rc-completed': isCompleted(4,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(4,'GL_POST_REPORT'); else step4Num">✓</ng-container>
                <ng-template #step4Num>4</ng-template>
              </span>
              <span class="rc-act-name">Management Response <br> Agreed?
                <span class="required">*</span>
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to RPTG - Mgmt Resp Agreed">info</mat-icon></span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glMRAgreed"
                [disabled]="!isActive(4,'GL_POST_REPORT') && !isCompleted(4,'GL_POST_REPORT')" (change)="onDateSelected(4,'GL_POST_REPORT')"
                placeholder="mm/dd/yyyy" /> -->
              <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postreport4, 4, 'GL_POST_REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(glMRAgreed) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postreport4 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glMRAgreed"
                [disabled]="!isActive(4,'GL_POST_REPORT') && !isCompleted(4,'GL_POST_REPORT')"
                (change)="onDateSelected(4,'GL_POST_REPORT')" />
            </div>
            </div>

            <!-- 5 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,'GL_POST_REPORT'),
          'rc-completed': isCompleted(5,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(5,'GL_POST_REPORT'); else step5Num">✓</ng-container>
                <ng-template #step5Num>5</ng-template>
              </span>
              <span class="rc-act-name">Closing Call to Agree on <br> MRs (Optional)</span>
              <!-- <div class="step-group">
              <label>
                <input type="radio" name="step5" value="yes" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5, 'REPORT')">
                Yes
              </label>

              <label>
                <input type="radio" name="step5" value="no" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5, 'REPORT')">
                No
              </label>
            </div> -->
              <div class="step-group">

                <select [(ngModel)]="step5glTextValue" (change)="onTextChange(5, 'GL_POST_REPORT')"
                  class="status-dropdown status-pill" [ngClass]="{
                          'not-started': step5glTextValue === 'Not Started',
                          'in-progress': step5glTextValue === 'In Progress',
                          'completed': step5glTextValue === 'Completed'}">

                  <option value="Not Started">Not Started</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
            </div>

            <!-- 6 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6,'GL_POST_REPORT'),
          'rc-completed': isCompleted(6,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(6,'GL_POST_REPORT'); else step6Num">✓</ng-container>
                <ng-template #step6Num>6</ng-template>
              </span>
              <span class="rc-act-name">Update & Publish the Report</span>
              <div class="upload-section">
                <span class="rc-upload-link"
                  (click)="openUploadDocModal(6,'GL_POST_REPORT')">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                    <path
                      d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                  </svg>
                  Upload Document
                </span>

                <div *ngIf="uploadedFilesMap['GL_POST_REPORT'][6]?.length">
                  <div *ngFor="let file of uploadedFilesMap['GL_POST_REPORT'][6]; let i = index" class="file-display">
                    <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                    <mat-icon class="delete-icon" (click)="removeFile(6, i,'GL_POST_REPORT')">delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>

            <!-- 7 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7,'GL_POST_REPORT'),
          'rc-completed': isCompleted(7,'GL_POST_REPORT') }">
                <ng-container *ngIf="isCompleted(7,'GL_POST_REPORT'); else step7Num">✓</ng-container>
                <ng-template #step7Num>7</ng-template>
              </span>
              <span class="rc-act-name">
                Overall Report Review Rating <span class="required">*</span>
              </span>
              <div class="rc-dropdown-container">
                <div *ngIf="!isActive(7,'GL_POST_REPORT') && !isCompleted(7,'GL_POST_REPORT')"
                     class="rc-dropdown-overlay"
                     (click)="isBlockedBySequence(7,'GL_POST_REPORT')"></div>
                <select class="rc-dropdown" [(ngModel)]="glreportRating"
                  [disabled]="!isActive(7,'GL_POST_REPORT') && !isCompleted(7,'GL_POST_REPORT')"
                  (change)="onReportRatingChange(7, 'GL_POST_REPORT')">
                  <option value="">Select</option>
                  <option value="green">Green</option>
                  <option value="yellow">Yellow</option>
                  <option value="red">Red</option>
                  <option value="blue">Blue</option>
                </select>
              </div>
            </div>

            <!-- 8 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8,'GL_POST_REPORT'),
          'rc-completed': isCompleted(8,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(8,'GL_POST_REPORT'); else step8Num">✓</ng-container>
                <ng-template #step8Num>8</ng-template>
              </span>
              <span class="rc-act-name">Revised Target Publication Date
              </span>
              <div class="field-input rc-date-field rc-date-picker-wrap"
                [class.rc-revdate-field--disabled]="!isActive(8,'GL_POST_REPORT') && !isCompleted(8,'GL_POST_REPORT')"
                (click)="openRevisedPubDateModal()">
                <span class="rc-date-display">
                  {{ revisedTargetPublicationDate ? (revisedTargetPublicationDate | date:'dd-MMM-yyyy') : 'DD-MMM-YYYY'
                  }}
                </span>
                <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              </div>
            </div>

            <!-- 9 -->
            <div class="rc-activity">
              <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9,'GL_POST_REPORT'),
          'rc-completed': isCompleted(9,'GL_POST_REPORT')}">
                <ng-container *ngIf="isCompleted(9,'GL_POST_REPORT'); else step9Num">✓</ng-container>
                <ng-template #step9Num>9</ng-template>
              </span>
              <span class="rc-act-name">Actual Publishing Date<span class="required">*</span>
                <mat-icon class="icon-info" matTooltipPosition="above"
                  matTooltip="Once completed this activity the Review Status will change to IM - Published - Issue Management">info</mat-icon></span>
              <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="glactualPublishingDate"
                [disabled]="!isActive(9,'GL_POST_REPORT') && !isCompleted(9,'GL_POST_REPORT')" (change)="onDateSelected(9,'GL_POST_REPORT')"
                placeholder="mm/dd/yyyy" /> -->
                <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_postreport9, 9, 'GL_POST_REPORT')">
              <span class="rc-date-display">{{ formatDateDisplay(glactualPublishingDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_postreport9 type="date" class="rc-date-input-hidden"
                [(ngModel)]="glactualPublishingDate"
                [disabled]="!isActive(9,'GL_POST_REPORT') && !isCompleted(9,'GL_POST_REPORT')"
                (change)="onDateSelected(9,'GL_POST_REPORT')" />
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- On-Demand(3) and Special Review(4) -->
     <div class="rc-phases-wrap" *ngIf="reviewTypeId === 3 || reviewTypeId === 4">
      <!-- Plan Review -->
      <div class="rc-phase">
        <div class="rc-phase-hdr rc-phase-hdr--plan">
          <span class="rc-phase-title">Plan Review</span>
          <div class="rc-phase-hdr-right">
            <a class="rc-not-applicable" (click)="!isPlanReviewReadOnly && openNotApplicableModal()">Not Applicable</a>
            <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus(getPhaseName('PLAN')) === 'NOT_STARTED',
              'in-progress': getStatus(getPhaseName('PLAN')) === 'IN_PROGRESS',
              'completed': getStatus(getPhaseName('PLAN')) === 'COMPLETED'}">

              <!-- icon -->
              <ng-container *ngIf="getStatus(getPhaseName('PLAN')) === 'NOT_STARTED'; else odrprogressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>

              <ng-template #odrprogressIcon>
                <ng-container *ngIf="getStatus(getPhaseName('PLAN')) === 'IN_PROGRESS'; else odrcompletedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>

              <ng-template #odrcompletedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>

            </span>
          </div>
        </div>

        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1,getPhaseName('PLAN')),
          'rc-completed': isCompleted(1,getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(1,getPhaseName('PLAN')); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Initial Communication <br> Send <span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to PL - Initial Communication Sent"
                matTooltipPosition="above">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(1,getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][1]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][1]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(1, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 2. Kick off meeting -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,getPhaseName('PLAN')),
          'rc-completed': isCompleted(2,getPhaseName('PLAN')) }">
              <ng-container *ngIf="isCompleted(2,getPhaseName('PLAN')); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <span class="rc-act-name">
              Kick Off Meeting
            </span>
            <input type="text" class="field-input rc-date-field kickoffDate" [value]="formatDateDisplay(kickoffDate)" readonly />
          </div>

          <!-- 3. Actual kick off date -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3, getPhaseName('PLAN')),
          'rc-completed': isCompleted(3, getPhaseName('PLAN')) }">
              <ng-container *ngIf="isCompleted(3, getPhaseName('PLAN')); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Actual Kick Off Date <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to PL - Kick Off Call Held">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-date-picker-wrap--disabled]="isPlanReviewReadOnly"
              (click)="openDatePicker(rcPicker_osplan3, 3, getPhaseName('PLAN'))">
              <span class="rc-date-display">{{ formatDateDisplay(actualKickoffDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_osplan3 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualKickoffDate"
                [disabled]="isPlanReviewReadOnly || !isActive(3, getPhaseName('PLAN')) && !isCompleted(3, getPhaseName('PLAN'))"
                (change)="onDateSelected(3, getPhaseName('PLAN'))" />
            </div>
          </div>

          <!-- 4. Meeting Minutes of Kick of Meeting Sent -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4, getPhaseName('PLAN')),
          'rc-completed': isCompleted(4, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(4, getPhaseName('PLAN')); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Meeting Minutes of Kick Off Meeting Sent</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(4, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][4]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][4]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(4, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 5. Request send for Required Document -->

          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5, getPhaseName('PLAN')),
          'rc-completed': isCompleted(5, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(5, getPhaseName('PLAN')); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Request Send for Required Document Received (Section-1)</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(5, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][5]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][5]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(5, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 6. Risk Assessment & draft Engagement Letter -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6, getPhaseName('PLAN')),
          'rc-completed': isCompleted(6, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(6, getPhaseName('PLAN')); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Risk Assessment &amp; Draft Engagement Letter (EL)</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(6, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][6]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][6]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(6, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7, getPhaseName('PLAN')),
          'rc-completed': isCompleted(7, getPhaseName('PLAN')) }">
              <ng-container *ngIf="isCompleted(7, getPhaseName('PLAN')); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Actual Planning Meeting <br> Date<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to PL - FW Confirmed">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-date-picker-wrap--disabled]="isPlanReviewReadOnly"
              (click)="openDatePicker(rcPicker_osplan7, 7, getPhaseName('PLAN'))">
              <span class="rc-date-display">{{ formatDateDisplay(actualPlanningDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_osplan7 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualPlanningDate"
                [disabled]="isPlanReviewReadOnly || !isActive(7, getPhaseName('PLAN')) && !isCompleted(7, getPhaseName('PLAN'))"
                (change)="onDateSelected(7, getPhaseName('PLAN'))" />
            </div>
          </div>

          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8, getPhaseName('PLAN')),
          'rc-completed': isCompleted(8, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(8, getPhaseName('PLAN')); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Meeting Minutes Documented &amp; Distributed (Planning Meeting) <span
                class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to SCP – Engagement Letter Issued">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(8, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][8]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][8]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(8, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9, getPhaseName('PLAN')),
          'rc-completed': isCompleted(9, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(9, getPhaseName('PLAN')); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">EL is Published<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to SCP - Engagement Letter Issued">info</mat-icon>
            </span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(9, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][9]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][9]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(9, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 10 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(10, getPhaseName('PLAN')),
          'rc-completed': isCompleted(10, getPhaseName('PLAN'))}">
              <ng-container *ngIf="isCompleted(10, getPhaseName('PLAN')); else step10Num">✓</ng-container>
              <ng-template #step10Num>10</ng-template>
            </span>
            <span class="rc-act-name">Requested Document Received from Delivery Team (Section 2)</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                [class.disabled]="isPlanReviewReadOnly"
                (click)="!isPlanReviewReadOnly && openUploadDocModal(10, getPhaseName('PLAN'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('PLAN')][10]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('PLAN')][10]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(10, i, getPhaseName('PLAN'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Conduct Review -->
      <div class="rc-phase">
        <div class="rc-phase-hdr rc-phase-hdr--conduct">
          <span class="rc-phase-title">Conduct Review</span>
          <div class="rc-phase-hdr-right">
            <span class="rc-status-badge" [ngClass]="{
              'not-started': getStatus(getPhaseName('CONDUCT')) === 'NOT_STARTED',
              'in-progress': getStatus(getPhaseName('CONDUCT')) === 'IN_PROGRESS',
              'completed': getStatus(getPhaseName('CONDUCT')) === 'COMPLETED'}">

              <!-- icon -->
              <ng-container *ngIf="getStatus(getPhaseName('CONDUCT')) === 'NOT_STARTED'; else odrconductprogressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>

              <ng-template #odrconductprogressIcon>
                <ng-container *ngIf="getStatus(getPhaseName('CONDUCT')) === 'IN_PROGRESS'; else odrconductcompletedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>

              <ng-template #odrconductcompletedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>
            </span>
          </div>
        </div>

        <!-- Activity -->
        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(1, getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(1, getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(1, getPhaseName('CONDUCT')); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Actual Fieldwork Start Date<span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to FW - Started"
                matTooltipPosition="above">info</mat-icon>
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osconduct1, 1, getPhaseName('CONDUCT'))">
              <span class="rc-date-display">{{ formatDateDisplay(actualFieldWorkStartDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_osconduct1 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualFieldWorkStartDate"
                [disabled]="!isActive(1, getPhaseName('CONDUCT')) && !isCompleted(1, getPhaseName('CONDUCT'))"
                (change)="onDateSelected(1, getPhaseName('CONDUCT'))" />
            </div>
          </div>

                    <!-- 2 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(2,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(2,getPhaseName('CONDUCT')) }">
              <ng-container *ngIf="isCompleted(2,getPhaseName('CONDUCT')); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <span class="rc-act-name">
              Review documentation and define the controls to be tested (Offline)
            </span>
            <div class="step-group step-group--compact">
              <label>
                <input type="radio" name="step2" value="yes" [(ngModel)]="step2TextValue"
                  (change)="onTextChange(2,getPhaseName('CONDUCT'))">
                Yes
              </label>

              <label>
                <input type="radio" name="step2" value="no" [(ngModel)]="step2TextValue"
                  (change)="onTextChange(2,getPhaseName('CONDUCT'))">
                No
              </label>
            </div>
          </div>

          <!-- 3 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(3,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(3,getPhaseName('CONDUCT')) }">
              <ng-container *ngIf="isCompleted(3,getPhaseName('CONDUCT')); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Agree review plan on Opening Call
            </span>
            <label class="switch switch--green">
              <input type="checkbox" [(ngModel)]="step3ToggleValue" [disabled]="isCancelled || isReadOnly"
                (change)="onToggleChange(3,getPhaseName('CONDUCT'))">
              <span class="slider"></span>
            </label>
          </div>

          <!-- 4 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(4,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(4,getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(4,getPhaseName('CONDUCT')); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Perform Fieldwork and document result in the Working Papers</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(4,getPhaseName('CONDUCT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('CONDUCT')][4]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('CONDUCT')][4]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(4, i,getPhaseName('CONDUCT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 5 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(5,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(5,getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(5,getPhaseName('CONDUCT')); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Discuss Status and observation within schedule Interim Meeting</span>

            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(5,getPhaseName('CONDUCT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('CONDUCT')][5]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('CONDUCT')][5]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(5, i,getPhaseName('CONDUCT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 6 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(6,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(6,getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(6,getPhaseName('CONDUCT')); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Actual Fieldwork End Date <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to FW - Completed">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osconduct6, 6, getPhaseName('CONDUCT'))">
              <span class="rc-date-display">{{ formatDateDisplay(actualFieldWorkEndDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_osconduct6 type="date" class="rc-date-input-hidden"
                [(ngModel)]="actualFieldWorkEndDate"
                [disabled]="!isActive(6,getPhaseName('CONDUCT')) && !isCompleted(6,getPhaseName('CONDUCT'))"
                (change)="onDateSelected(6,getPhaseName('CONDUCT'))" />
            </div>
          </div>

          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(7,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(7,getPhaseName('CONDUCT')) }">
              <ng-container *ngIf="isCompleted(7,getPhaseName('CONDUCT')); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Prepare issue summary (iSAD) and share with SDL and team lead
            </span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(7,getPhaseName('CONDUCT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('CONDUCT')][7]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('CONDUCT')][7]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(7, i,getPhaseName('CONDUCT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(8,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(8,getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(8,getPhaseName('CONDUCT')); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Pre-closing is held to agree on observations</span>
            <!-- <input type="date" class="field-input rc-date-field" [(ngModel)]="preClosingHeld"
              [disabled]="!isActive(8,'CONDUCT') && !isCompleted(8,'CONDUCT')" (change)="onDateSelected(8,'CONDUCT')" placeholder="mm/dd/yyyy" /> -->
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(8, getPhaseName('CONDUCT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('CONDUCT')][8]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('CONDUCT')][8]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(8, i,getPhaseName('CONDUCT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(9,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(9,getPhaseName('CONDUCT'))}">
              <ng-container *ngIf="isCompleted(9,getPhaseName('CONDUCT')); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">Actual Pre-Closing Call Meeting<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Pre Close Call Held">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osconduct9, 9, getPhaseName('CONDUCT'))">
              <span class="rc-date-display">{{ formatDateDisplay(preClosingCall) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
              <input #rcPicker_osconduct9 type="date" class="rc-date-input-hidden"
                [(ngModel)]="preClosingCall"
                [disabled]="!isActive(9,getPhaseName('CONDUCT')) && !isCompleted(9,getPhaseName('CONDUCT'))"
                (change)="onDateSelected(9,getPhaseName('CONDUCT'))" />
            </div>
          </div>

          <!-- 10 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
          'rc-act-num--active': isActive(10,getPhaseName('CONDUCT')),
          'rc-completed': isCompleted(10,getPhaseName('CONDUCT')) }">
              <ng-container *ngIf="isCompleted(10,getPhaseName('CONDUCT')); else step10Num">✓</ng-container>
              <ng-template #step10Num>10</ng-template>
            </span>
            <span class="rc-act-name">
              Distribute Minutes of meeting of Pre-Closing Call<span class="required">*</span><mat-icon
                class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Pre Close Call Held">info</mat-icon>
            </span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(10, getPhaseName('CONDUCT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>

              <div *ngIf="uploadedFilesMap[getPhaseName('CONDUCT')][10]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('CONDUCT')][10]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(10, i,getPhaseName('CONDUCT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Review -->
      <div class="rc-phase rc-phase--report">
        <div class="rc-phase-hdr rc-phase-hdr--report">
          <span class="rc-phase-title">Report the Review</span>
          <div class="rc-phase-hdr-right">
            <span class="rc-status-badge" [ngClass]="{
                    'not-started': getStatus(getPhaseName('REPORT')) === 'NOT_STARTED',
                    'in-progress': getStatus(getPhaseName('REPORT')) === 'IN_PROGRESS',
                    'completed': getStatus(getPhaseName('REPORT')) === 'COMPLETED'}">
      
              <!-- icon -->
              <ng-container *ngIf="getStatus(getPhaseName('REPORT')) === 'NOT_STARTED'; else odrreportprogressIcon">
                <svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                Not Started
              </ng-container>
      
              <ng-template #odrreportprogressIcon>
                <ng-container *ngIf="getStatus(getPhaseName('REPORT')) === 'IN_PROGRESS'; else odrreportcompletedIcon">
                  <mat-icon>schedule</mat-icon>
                  In Progress
                </ng-container>
              </ng-template>
      
              <ng-template #odrreportcompletedIcon>
                <mat-icon>check_circle</mat-icon> Completed
              </ng-template>
            </span>
          </div>
        </div>
      
        <!-- Activity -->
        <div class="rc-activity-list">
          <!-- 1 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(1,getPhaseName('REPORT')),
                'rc-completed': isCompleted(1,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(1,getPhaseName('REPORT')); else step1Num">✓</ng-container>
              <ng-template #step1Num>1</ng-template>
            </span>
            <span class="rc-act-name">Draft report based on <br> agreed ISAD</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(1,getPhaseName('REPORT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>
      
              <div *ngIf="uploadedFilesMap[getPhaseName('REPORT')][1]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('REPORT')][1]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(1, i,getPhaseName('REPORT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
      
          <!-- 2 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(2,getPhaseName('REPORT')),
                'rc-completed': isCompleted(2,getPhaseName('REPORT')) }">
              <ng-container *ngIf="isCompleted(2,getPhaseName('REPORT')); else step2Num">✓</ng-container>
              <ng-template #step2Num>2</ng-template>
            </span>
            <!-- <span class="rc-act-name"></span> -->
            <div class="rc-act-content">
              <span class="rc-act-name">Review/update Report</span>
      
              <!-- Sub item 1 -->
              <div class="rc-sub-item">
                <span>1. Reviewed by Manager</span>
                <label>
                  <input type="radio" name="mgr1" value="yes" [(ngModel)]="reportReview.reviewedByManager"
                    (change)="onSubChange()">
                  Yes
                </label>
      
                <label>
                  <input type="radio" name="mgr1" value="no" [(ngModel)]="reportReview.reviewedByManager"
                    (change)="onSubChange()">
                  No
                </label>
              </div>
      
              <!-- Sub item 2 -->
              <div class="rc-sub-item" [class.disabled]="!reportReview.reviewedByManager">
                <span>
                  2. Reviewed by Regional <br> Compliance Lead, <br>Global Risk and <br>Compliance
                </span>
      
                <label>
                  <input type="radio" name="comp1" value="yes" [(ngModel)]="reportReview.reviewedByCompliance"
                    [disabled]="!reportReview.reviewedByManager" (change)="onSubChange()">
                  Yes
                </label>
      
                <label>
                  <input type="radio" name="comp1" value="no" [(ngModel)]="reportReview.reviewedByCompliance"
                    [disabled]="!reportReview.reviewedByManager" (change)="onSubChange()">
                  No
                </label>
              </div>
            </div>
          </div>
      
          <!-- 3 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(3,getPhaseName('REPORT')),
                'rc-completed': isCompleted(3,getPhaseName('REPORT')) }">
              <ng-container *ngIf="isCompleted(3,getPhaseName('REPORT')); else step3Num">✓</ng-container>
              <ng-template #step3Num>3</ng-template>
            </span>
            <span class="rc-act-name">
              Send draft report for Management Response <br>(MR) <span class="required">*</span>
              <mat-icon class="icon-info"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Draft Sent for Mgmt Resp"
                matTooltipPosition="above">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osreport3, 3, getPhaseName('REPORT'))">
              <span class="rc-date-display">{{ formatDateDisplay(sendDraftReportforMR) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="3" y1="9" x2="21" y2="9" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="16" y1="2" x2="16" y2="6" />
              </svg>
              <input #rcPicker_osreport3 type="date" class="rc-date-input-hidden" [(ngModel)]="sendDraftReportforMR"
                [disabled]="!isActive(3,getPhaseName('REPORT')) && !isCompleted(3,getPhaseName('REPORT'))"
                (change)="onDateSelected(3,getPhaseName('REPORT'))" />
            </div>
          </div>
      
          <!-- 4 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(4,getPhaseName('REPORT')),
                'rc-completed': isCompleted(4,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(4,getPhaseName('REPORT')); else step4Num">✓</ng-container>
              <ng-template #step4Num>4</ng-template>
            </span>
            <span class="rc-act-name">Management Response <br> Agreed?
              <span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to RPTG - Mgmt Resp Agreed">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osreport4, 4, getPhaseName('REPORT'))">
              <span class="rc-date-display">{{ formatDateDisplay(MRAgreed) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="3" y1="9" x2="21" y2="9" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="16" y1="2" x2="16" y2="6" />
              </svg>
              <input #rcPicker_osreport4 type="date" class="rc-date-input-hidden" [(ngModel)]="MRAgreed"
                [disabled]="!isActive(4,getPhaseName('REPORT')) && !isCompleted(4,getPhaseName('REPORT'))"
                (change)="onDateSelected(4,getPhaseName('REPORT'))" />
            </div>
          </div>
      
          <!-- 5 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(5,getPhaseName('REPORT')),
                'rc-completed': isCompleted(5,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(5,getPhaseName('REPORT')); else step5Num">✓</ng-container>
              <ng-template #step5Num>5</ng-template>
            </span>
            <span class="rc-act-name">Closing call to agree on <br> MRs (Optional)</span>
            <div class="step-group step-group--align-end">
              <label>
                <input type="radio" name="step5" value="yes" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5,getPhaseName('REPORT'))">
                Yes
              </label>
      
              <label>
                <input type="radio" name="step5" value="no" [(ngModel)]="step5TextValue"
                  (change)="onTextChange(5, getPhaseName('REPORT'))">
                No
              </label>
            </div>
          </div>
      
          <!-- 6 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(6,getPhaseName('REPORT')),
                'rc-completed': isCompleted(6,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(6,getPhaseName('REPORT')); else step6Num">✓</ng-container>
              <ng-template #step6Num>6</ng-template>
            </span>
            <span class="rc-act-name">Update & publish the report</span>
            <div class="upload-section">
              <span class="rc-upload-link"
                (click)="openUploadDocModal(6,getPhaseName('REPORT'))">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
                  <path
                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
                Upload Document
              </span>
      
              <div *ngIf="uploadedFilesMap[getPhaseName('REPORT')][6]?.length">
                <div *ngFor="let file of uploadedFilesMap[getPhaseName('REPORT')][6]; let i = index" class="file-display">
                  <a class="file-name" [attr.title]="file.name" (click)="downloadDocument(file)">{{ file.name }}</a>
                  <mat-icon class="delete-icon" (click)="removeFile(6, i,getPhaseName('REPORT'))">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
      
          <!-- 7 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(7,getPhaseName('REPORT')),
                'rc-completed': isCompleted(7,getPhaseName('REPORT')) }">
              <ng-container *ngIf="isCompleted(7,getPhaseName('REPORT')); else step7Num">✓</ng-container>
              <ng-template #step7Num>7</ng-template>
            </span>
            <span class="rc-act-name">
              Overall Report Review <br>Rating <span class="required">*</span>
            </span>
            <div class="rc-dropdown-container">
              <div *ngIf="!isActive(7,getPhaseName('REPORT')) && !isCompleted(7,getPhaseName('REPORT'))"
                   class="rc-dropdown-overlay"
                   (click)="isBlockedBySequence(7,getPhaseName('REPORT'))"></div>
              <select class="rc-dropdown" [(ngModel)]="reportRating"
                [disabled]="!isActive(7,getPhaseName('REPORT')) && !isCompleted(7,getPhaseName('REPORT'))"
                (change)="onReportRatingChange(7, getPhaseName('REPORT'))">
                <option value="">Select</option>
                <option value="green">Green</option>
                <option value="yellow">Yellow</option>
                <option value="red">Red</option>
                <option value="blue">Blue</option>
              </select>
            </div>
          </div>
      
          <!-- 8 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(8,getPhaseName('REPORT')),
                'rc-completed': isCompleted(8,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(8,getPhaseName('REPORT')); else step8Num">✓</ng-container>
              <ng-template #step8Num>8</ng-template>
            </span>
            <span class="rc-act-name">Revised Target Publication <br>Date
            </span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              [class.rc-revdate-field--disabled]="!isActive(8,getPhaseName('REPORT')) && !isCompleted(8,getPhaseName('REPORT'))"
              (click)="openRevisedPubDateModal()">
              <span class="rc-date-display">
                {{ revisedTargetPublicationDate ? formatDateDisplay(revisedTargetPublicationDate) : 'DD-MMM-YYYY' }}
              </span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
            </div>
          </div>
      
          <!-- 9 -->
          <div class="rc-activity">
            <span class="rc-act-num" [ngClass]="{
                'rc-act-num--active': isActive(9,getPhaseName('REPORT')),
                'rc-completed': isCompleted(9,getPhaseName('REPORT'))}">
              <ng-container *ngIf="isCompleted(9,getPhaseName('REPORT')); else step9Num">✓</ng-container>
              <ng-template #step9Num>9</ng-template>
            </span>
            <span class="rc-act-name">Actual Publishing Date<span class="required">*</span>
              <mat-icon class="icon-info" matTooltipPosition="above"
                matTooltip="Once completed this activity the Review Status will change to IM - Published">info</mat-icon></span>
            <div class="field-input rc-date-field rc-date-picker-wrap"
              (click)="openDatePicker(rcPicker_osreport9, 9, getPhaseName('REPORT'))">
              <span class="rc-date-display">{{ formatDateDisplay(actualPublishingDate) || 'DD-MMM-YYYY' }}</span>
              <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="3" y1="9" x2="21" y2="9" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="16" y1="2" x2="16" y2="6" />
              </svg>
              <input #rcPicker_osreport9 type="date" class="rc-date-input-hidden" [(ngModel)]="actualPublishingDate"
                [disabled]="!isActive(9,getPhaseName('REPORT')) && !isCompleted(9,getPhaseName('REPORT'))"
                (change)="onDateSelected(9,getPhaseName('REPORT'))" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Not Applicable modal -->
  <div class="na-overlay" *ngIf="showNotApplicableModal" (click)="closeNotApplicableModal()">
    <div class="na-modal" (click)="$event.stopPropagation()">
      <!-- header -->
      <div class="na-modal-hdr">
        <span class="na-modal-title">Set to Not Applicable</span>
        <button type="button" class="na-close-btn" (click)="closeNotApplicableModal()" aria-label="Close">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#000" stroke="#fff" stroke-width="2">
            <circle cx="12" cy="12" r="11" fill="#000" stroke="none" />
            <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
            <line x1="15.5" y1="8.5" x2="8.5" y2="15.5" />
          </svg>
        </button>
      </div>

      <!-- body -->
      <div class="na-modal-body">
        <div class="na-field">
          <label class="na-label">Review ID</label>
          <div class="na-review-id">{{ notApplicableReviewId }}</div>
        </div>

        <div class="na-field">
          <label class="na-label">Reason for Not Applicable <span class="required">*</span></label>
          <textarea class="na-textarea" rows="4" [(ngModel)]="notApplicableReason"
            placeholder="Enter the reason for marking this Not Applicable"></textarea>
          <div class="field-error" *ngIf="showNotApplicableValidation && !notApplicableReason.trim()">
            Reason for Not Applicable is required.
          </div>
        </div>

        <p class="na-evidence-note">
          Please add supporting evidence or documents to proceed with the Not Applicable.
        </p>

        <label class="na-upload-link">
          <input type="file" multiple hidden (change)="onNotApplicableFileSelected($event)" />
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9d24ea" stroke-width="2">
            <path
              d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
          </svg>
          Upload Document
        </label>

        <div class="na-file-list" *ngIf="notApplicableFiles.length">
          <div *ngFor="let file of notApplicableFiles; let i = index" class="file-display">
            <a class="file-name" [attr.title]="file.name">{{ file.name }}</a>
            <mat-icon class="delete-icon" (click)="removeNotApplicableFile(i)">delete</mat-icon>
          </div>
        </div>

        <!-- <p class="na-dev-note">This feature is currently under development and will be available in a future update.</p> -->
      </div>

      <!-- footer -->
      <div class="na-modal-ftr">
        <button type="button" class="na-btn na-btn--cancel" (click)="closeNotApplicableModal()">Cancel</button>
        <button type="button" class="na-btn na-btn--confirm"
          [disabled]="!notApplicableReason.trim()"
          (click)="confirmNotApplicable()">Send Request</button>
      </div>
    </div>
  </div>

  <!-- Revised Target Publication Date Acknowledgement modal -->
  <div class="na-overlay" *ngIf="showRevisedPubDateModal" (click)="closeRevisedPubDateModal()">
    <div class="na-modal na-modal--revised-pub-date" (click)="$event.stopPropagation()">
      <div class="na-modal-hdr">
        <span class="na-modal-title">Revised Target Publication Date Acknowledgement</span>
      </div>

      <div class="na-modal-body">
        <div class="na-field">
          <label class="na-label">Revised publication date <span class="required">*</span></label>
          <div class="field-input rc-revdate-modal-input rc-date-picker-wrap"
            (click)="openDatePicker(rcPicker_revPub)">
            <span class="rc-date-display">{{ formatDateDisplay(revisedPublicationDate) || 'DD-MMM-YYYY' }}</span>
            <svg class="rc-date-cal-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>
            <input #rcPicker_revPub type="date" class="rc-date-input-hidden-revisedtargetdate"
              [max]="revisedPubDateMax" [(ngModel)]="revisedPublicationDate" />
          </div>

          <div class="field-error" *ngIf="showRevisedDateValidation && !revisedPublicationDate">
            Revised Publication Date is required.
          </div>
          <div class="field-error" *ngIf="showRevisedDateValidation && revisedPublicationDate && isRevisedPubDateBeyondLimit()">
            Revised Publication Date cannot be more than 180 days from today.
          </div>
        </div>

        <div class="na-field">
          <label class="na-label">Reason for revised the date <span class="required">*</span></label>
          <textarea class="na-textarea" rows="4" [(ngModel)]="revisedDateReason"
            placeholder="Enter the reason for the revised date"></textarea>
          <div class="field-error" *ngIf="showRevisedDateValidation && !revisedDateReason?.trim()">
            Reason for Revised Date is required.
          </div>
        </div>

        <p class="rev-ack-title">Revised Target Publication Date Acknowledgment</p>
        <p class="rev-ack-intro">
          By changing the 'Report Publication Date' to
          {{ formatDateDisplay(revisedPublicationDate) }}, the Reviewer, confirm the
          following:
        </p>
        <p class="rev-ack-item">
          I have <strong>informed the Manager</strong> of this change and ensured they are <strong>fully aware</strong>
          and in agreement with the new<br />'Revised Publication Date'.
        </p>

        <label class="rev-ack-check">
          <input type="checkbox" [(ngModel)]="revisedDateAcknowledged" />
          <strong>I acknowledge, understand, and agree to the terms above</strong>
        </label>
      </div>

      <div class="na-modal-ftr">
        <button type="button" class="na-btn na-btn--cancel" (click)="closeRevisedPubDateModal()">Cancel</button>
          @if(glActiveTab === 'post'){
        <button type="button" class="na-btn na-btn--confirm"
          [disabled]="!revisedDateAcknowledged || !revisedPublicationDate || !revisedDateReason?.trim()"
          (click)="submitRevisedPubDate('GL_POST_REPORT')">Send Request</button> }
          @else{
        <button type="button" class="na-btn na-btn--confirm"
          [disabled]="!revisedDateAcknowledged || !revisedPublicationDate || !revisedDateReason?.trim()"
          (click)="submitRevisedPubDate(getPhaseName('REPORT'))">Send Request</button> }
      </div>
    </div>
  </div>

  <!-- Upload Document modal -->
  <div class="ud-overlay" *ngIf="showUploadDocModal">
    <div class="ud-modal">
      <div class="ud-header">
        <span class="ud-title">Upload Document</span>
        <button class="ud-close-btn" (click)="closeUploadDocModal()">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#1a1a1a">
            <circle cx="12" cy="12" r="12" />
            <line x1="8" y1="8" x2="16" y2="16" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
            <line x1="16" y1="8" x2="8" y2="16" stroke="#fff" stroke-width="2.2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="ud-body">
        <label class="ud-upload-btn">
          <input type="file" multiple hidden (change)="onUploadModalFileSelected($event)" />
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <path
              d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
          </svg>
          Upload Document
        </label>
        <h4 class="ud-instructions-title">Instruction Related to Upload Document</h4>
        <ol class="ud-instructions">
          <li><strong>&nbsp; Format Supported:</strong> PDF (.pdf), Outlook Mail (.msg), Excel (.xls, .xlsx), Word (.doc, .docx), Text (.txt), PowerPoint (.ppt, .pptx), Image (.jpg, .jpeg, .png), ZIP (.zip).</li>
          <li><strong>&nbsp; File Size Limit:</strong> The maximum allowable file size for import is 20MB. Files exceeding this limit must be split and upload separately.</li>
          <li><strong>&nbsp; User Permissions:</strong> You must have the necessary permissions within the system to
            upload the document.</li>
          <li><strong>&nbsp; Offline Approval Status:</strong> Confirmation of offline approval for the data you are
            uploading must be secured before starting the upload process.</li>
          <li><strong>&nbsp; Data Classification Restriction: </strong> Uploading documents classified as <strong>Confidential,
            Highly Confidential, Personal Data, or Restricted Data</strong> is strictly prohibited. Only approved non-sensitive
            documents may be uploaded.</li>
        </ol>
      </div>
    </div>
  </div>

  <!-- Warning modal -->
  <div class="rc-warn-overlay" *ngIf="showWarningModal">
    <div class="rc-warn-modal">
      <div class="rc-warn-hdr">
        <mat-icon class="rc-warn-icon">warning</mat-icon>
        <span class="rc-warn-title">Warning</span>
      </div>
      <div class="rc-warn-body">
        <p class="rc-warn-text">{{ warningMessage }}</p>
        <div class="rc-warn-ftr">
          <button type="button" class="rc-warn-btn" (click)="closeWarning()">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Out-of-sequence mandatory activity warning -->
  <div class="rc-warn-overlay" *ngIf="showSequenceWarningModal">
    <div class="rc-warn-modal">
      <div class="rc-warn-hdr">
        <mat-icon class="rc-warn-icon">warning</mat-icon>
        <span class="rc-warn-title">Warning</span>
      </div>
      <div class="rc-warn-body">
        <p class="rc-warn-text">You must complete the previous mandatory activity before you can mark this activity as completed.</p>
        <div class="rc-warn-ftr">
          <button type="button" class="rc-warn-btn" (click)="closeSequenceWarning()">Okay, I acknowledged</button>
        </div>
      </div>
    </div>
  </div>
</div>